import { useToastManager } from "@maker/design-system/ui/toast";
import { useNavigate } from "react-router";
import {
	type CreateTranscriptionInput,
	useCreateTranscription,
} from "../../../../hooks/use-transcriptions";
import { TranscriptionsForm } from "./_elements/form";
import { TranscriptionsProgress } from "./_elements/progress";

const TranscriptionsCreatePage = () => {
	const navigate = useNavigate();
	const toastManager = useToastManager();
	const { mutate, isPending, isSuccess } = useCreateTranscription();

	const handleSubmit = (input: CreateTranscriptionInput) => {
		mutate(input, {
			onSuccess: (data) => navigate(`/${data.id}`),
			onError: () =>
				toastManager.add({
					title: "Ocorreu um erro ao criar a transcrição",
				}),
		});
	};

	return (
		<>
			{!isPending && !isSuccess && (
				<TranscriptionsForm onSubmit={handleSubmit} />
			)}

			{isPending && <TranscriptionsProgress />}
		</>
	);
};

export default TranscriptionsCreatePage;
